export interface ICancellable {
  cancel: () => void;
}

declare global {
  interface FunctionConstructor {
    debounce: <T extends (...args: any[]) => any>(
      target: T,
      wait?: number
    ) => ((...args: Parameters<T>) => void) & ICancellable;
    NOOP: () => void;
  }

  interface Function {
    bzDebounce: <T extends (...args: any[]) => any>(
      this: T,
      wait?: number
    ) => ((...args: Parameters<T>) => void) & ICancellable;
  }
}

if (!Function.NOOP) {
  Object.defineProperty(Function, 'NOOP', {
    writable: false,
    enumerable: false,
    value: () => {
      return;
    }
  });
}

if (!Function.debounce) {
  Object.defineProperty(Function, 'debounce', {
    writable: false,
    enumerable: false,
    value: function <T extends (...args: any[]) => any>(
      target: T,
      wait?: number
    ): ((...args: Parameters<T>) => void) & ICancellable {
      if (wait != null && wait < 0) {
        throw new RangeError('[Function.debounce] - Wait cannot be negative');
      }

      let timer: number | undefined;

      return Object.defineProperties(
        (...args: Parameters<T>): void => {
          window.clearTimeout(timer);
          timer = window.setTimeout(() => target(...args), wait);
        },
        {
          cancel: {
            value: () => window.clearTimeout(timer)
          }
        }
      ) as ((...args: Parameters<T>) => void) & ICancellable;
    }
  });
}

if (!Function.prototype.bzDebounce) {
  Object.defineProperty(Function.prototype, 'bzDebounce', {
    writable: false,
    enumerable: false,
    value: function <T extends (...args: any[]) => any>(
      this: T,
      wait?: number
    ): ((...args: Parameters<T>) => void) & ICancellable {
      if (wait != null && wait < 0) {
        throw new RangeError('[Function.bzDebounce] - Wait cannot be negative');
      }

      let timer: number | undefined;

      return Object.defineProperties(
        (...args: Parameters<T>): void => {
          window.clearTimeout(timer);
          timer = window.setTimeout(() => this(...args), wait);
        },
        {
          cancel: {
            value: () => window.clearTimeout(timer)
          }
        }
      ) as ((...args: Parameters<T>) => void) & ICancellable;
    }
  });
}
